import { Injectable } from '@angular/core';
import { ToastService } from 'src/app/services/toast/toast.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { take } from 'rxjs/operators';
import { hight_schools } from './current_sports.model';
import { schools } from 'src/app/views/email-coach/email-coach.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class currentSportsBLL {

  private isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  readonly isLoading$: Observable<boolean> = this.isLoading.asObservable();

  private current_experience: BehaviorSubject<any> =
    new BehaviorSubject<any>(null);
  readonly current_experience$: Observable<any> = this.current_experience.asObservable();

  private high_schools: BehaviorSubject<hight_schools> = new BehaviorSubject<hight_schools>(
    undefined
  );
  readonly high_schools$: Observable<hight_schools> = this.high_schools.asObservable();


  private is_high_schools_loading: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  readonly is_high_schools_loading$: Observable<boolean> =
    this.is_high_schools_loading.asObservable();


  constructor(private api: ApiService, private toast: ToastService, private auth: AuthService, private http: HttpClient) { }


  public async updateCurrentExperience(current_experience) {

    this.isLoading.next(true);
    let url = `athlete?type=current_experience`;

    this.api
      .patch(url, current_experience)
      .subscribe(
        async (response) => {
          this.toast.showToast(
            'Updated',
            'Your current experience updated successfully.'
          );
          this.getCurrentExperience();
          this.isLoading.next(false);
        },
        async (err) => {
          this.toast.showToast('Error!', 'Something went wrong!', 'danger');
          this.isLoading.next(false);
        }
      );
  }

  get_current_schools_email(keyword: string, source?: string) {
    this.is_high_schools_loading.next(true);

    this.auth.auth$.pipe(take(1)).subscribe((user: any) => {
      if (user?.token) {
        let url = ``;
        if (source === 'new-league') {
          url = `athlete?type=high_schools&search=${keyword}&page=1&limit=100`;
        } else {
          url = `email?type=schools&search=${keyword}`;
        }
        this.api
          .get(url)
          .pipe(take(1))
          .subscribe(
            (res: schools) => {
              const transformedResponse: hight_schools = {
                schools: res.schools.map(school => ({
                  id: school.id,
                  name: school.name || school.school,
                  created_at: school.created_at
                }))
              };
              this.high_schools.next(transformedResponse);
              this.is_high_schools_loading.next(false);
            },
            (err) => {
              this.is_high_schools_loading.next(false);
            }
          );
      } else {
        let url = `contracts?type=high_schools&search=${keyword}&page=1&limit=100`;
        this.http
          .get(environment.unauth_api_url + url)
          .pipe(take(1))
          .subscribe(
            (res: any) => {
              const schoolsList = res.schools || [];
              const transformedResponse: hight_schools = {
                schools: schoolsList.map((school: any) => ({
                  id: school.id,
                  name: school.name || school.school,
                  created_at: school.created_at
                }))
              };
              this.high_schools.next(transformedResponse);
              this.is_high_schools_loading.next(false);
            },
            (err) => {
              this.is_high_schools_loading.next(false);
            }
          );
      }
    });
  }

  get_current_schools(keyword: string, source?: string) {
    this.is_high_schools_loading.next(true);

    let url = ``;
    if (source === 'new-league') {
      url = `athlete?type=high_schools&search=${keyword}&page=1&limit=100`;
    } else {
      url = `email?type=schools&search=${keyword}`;
    }
    this.api
      .get(url)
      .pipe(take(1))
      .subscribe(
        (res: hight_schools) => {
          this.high_schools.next(res);
          this.is_high_schools_loading.next(false);
        },
        (err) => {
          this.is_high_schools_loading.next(false);
        }
      )
  }

  clear_high_schools() {
    this.high_schools.next({ schools: [] });
  }

  public async getCurrentExperience() {

    this.isLoading.next(true);
    let url = 'athlete?type=get_current_experience';

    this.api
      .get(url)
      .pipe(take(1))
      .subscribe(res => {
        this.current_experience.next(res[0]);
        console.log('response', res[0]);
        this.isLoading.next(false);
      },
        (err) => { }
      );
  }

}
